import type { QuestionnaireStatus } from '@/api/auth/types';

export const needsQuestionnaire = (status: QuestionnaireStatus) =>
  !status.hasSubmittedQuestionnaire || status.pendingQuestionIds.length > 0;
